import { useHookstate } from '@hookstate/core';
import { I18n } from 'aws-amplify';
import React from 'react';
import { currentInstallation } from '../ScrbTools';
import { InputSwitch } from 'primereact/inputswitch';
import { InputText } from "primereact/inputtext";
import { FloatLabel } from 'primereact/floatlabel';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import ConditionalComponent from '../ConditionalComponent';
import { installationRules } from '../Rules';

CertificatsGaz.propTypes = {
    editable: PropTypes.bool.isRequired
}

export default function CertificatsGaz(props) {

    const installation = useHookstate(currentInstallation);

    const onChange = (event) => {
        if (["certifFume1", "certifFume2"].includes(event.target.name)) {
            installation.certifFume1.set(0);
            installation.certifFume2.set(0);
        }
        const value = event.value ? 1 : 0;

        installation[event.target.name].set(value);
    }

    return <div className="flex flex-column pt-5">
        <h2 className="text-xl font-semibold mb-4">
            <i className="fa-light fa-file-signature" style={{ marginRight: '0.5rem' }}></i>
            {I18n.get("titreCertifGaz")}
        </h2>
        <div className='flex flex-row'>
            <div className="pr-2">
                <InputSwitch
                    name="certifGaz"
                    onChange={onChange}
                    checked={installation.get().certifGaz === 1}
                    className={classNames({
                        "p-invalid": !installation.get().certifGaz
                    })}
                    disabled={!props.editable}
                />
            </div>
            <p className="m-0" style={{ lineHeight: '1.5' }}>{I18n.get("certifGaz")}</p>
        </div>
        <h2 className="text-xl font-semibold mb-4 pt-4">
            <i className="fa-light fa-file-signature" style={{ marginRight: '0.5rem' }}></i>
            {I18n.get("titreCertifFume")}
        </h2>
        <div className='flex flex-row'>
            <div className="pr-2">
                <InputSwitch
                    name="certifFume1"
                    onChange={onChange}
                    checked={installation.get().certifFume1 === 1}
                    className={classNames({
                        "p-invalid": !installation.get().certifFume1 && !installation.get().certifFume2
                    })}
                    disabled={!props.editable}
                />
            </div>
            <p className="m-0" style={{ lineHeight: '1.5' }}>{I18n.get("certifFume1")}</p>
        </div>
        <hr />
        <div className="flex flex-row">
            <div className="pr-2">
                <InputSwitch
                    name="certifFume2"
                    onChange={onChange}
                    checked={installation.get().certifFume2 === 1}
                    className={classNames({
                        "p-invalid": !installation.get().certifFume2 && !installation.get().certifFume1
                    })}
                    disabled={!props.editable}
                />
            </div>
            <p className="m-0" style={{ lineHeight: '1.5' }}>{I18n.get("certifFume2")}</p>
        </div>
        <ConditionalComponent
            objState={installation}
            rules={installationRules}
            id={["certifFume2"]}
            component={
                <div className="flex flex-row pt-4">
                    <FloatLabel>
                        <InputText
                            id="certFumiste"
                            value={installation.get().certFumiste || ""}
                            onChange={(event => installation.certFumiste.set(event.target.value))}
                            className={classNames("w-full", { "p-invalid": !installation.get().certFumiste })}
                            disabled={!props.editable}
                            maxLength={100}
                        />
                        <label htmlFor="certFumiste">{I18n.get("certifFumiste")}</label>
                    </FloatLabel>
                </div>
            }
        />
    </div >
}